import { render, staticRenderFns } from "./ArchiveClientPopUp.vue?vue&type=template&id=ffdd9686&scoped=true&"
import script from "./ArchiveClientPopUp.vue?vue&type=script&lang=js&"
export * from "./ArchiveClientPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveClientPopUp.vue?vue&type=style&index=0&id=ffdd9686&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdd9686",
  null
  
)

export default component.exports